import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        domain: process.env.VUE_APP_URL,
        language: '', // english // emptpy for french
        locale: 'fr-FR', // eng-Eng // fr-FR
        locked: false,
        sivecNumber: '',
        sivecNumberConfirmation: false,
        appointmentId: null,
        plateNumber: '',
        vehicleType: '',
        vehicleTypeId: '',
        availableDates: [],
        selectedDate: '',
        selectedDateId: '',
        appointmentAt: '',
        selectedTime: '',
        dateSelection: false,
        materialSelection: [],
        phone: '',
        email: '',
        summarySection: false,
        errorMessage: '',
        errorCode: '',
        calendarKey: 0,
        newsletter: false,
        confirmation: false,
        imageFiles: [],
        isSubmitting: false,
        isExistingAppointment: false,
        confirmationToken: null,
        availableWasteTypes: []
    },
    mutations: {
        showSection (state, section) {
          state[section] = true;
        },
        hideSection (state, section) {
          state[section] = false;
        },
        changeData (state, data) {
          state[data.type] = data.value;
        },
        lockApp (state) {
          state.locked = true;
        },
        addErrorMessage (state, message) {
          state.errorMessage = message;
        }
    },
    actions: {
        resetCalendar(context) {
          context.state.calendarKey = context.state.calendarKey + 1
          context.state.selectedTime = ''
          context.state.appointmentAt = ''
        }
    }
});

export default store;
